import { render } from "./AddressItem.vue?vue&type=template&id=054d249a"
import script from "./AddressItem.vue?vue&type=script&lang=js"
export * from "./AddressItem.vue?vue&type=script&lang=js"
script.render = render

export default script